
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import './plugins/class-component'
import '@/components/index'
import '@/styles/tailwind.scss'
import { setToken } from '@/utils/HttpClient'
import VueSocketIO from 'vue-socket.io'
import { ServerConfig } from './config'

Vue.config.productionTip = false

Vue.use(new VueSocketIO({
    debug: true,
    connection: ServerConfig.SOCKET_URL,
    vuex: {
        store,
        actionPrefix: 'SOCKET_',
        mutationPrefix: 'SOCKET_'
    }
}))

new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
    created() {
        const token = localStorage.getItem('token')
        setToken(token)
    }
}).$mount('#app')
